import { useFeature } from "~hooks/useFeature";
import { CrowdCoursingLogo, SpaceFloridaFullLogo, SpaceFloridaOrbitLogo } from "~ui/atoms/Icons";

export type AppLogoVariant = "logoWithTagline" | "navBarLogo";

export interface AppLogoProps {
  logo?: AppLogoVariant;
  style?: { height?: string };
}

function getOrbitLogoSx(style?: { height?: string }) {
  return style?.height
    ? {
        display: "block",
        height: "auto",
        maxHeight: `${style.height} !important`,
        maxWidth: "100%",
        width: "auto",
      }
    : { display: "block", height: "auto", width: "100%" };
}

/** Brand logo driven by isSpaceFlorida and isOrbit (Space Florida ORBIT vs CrowdCoursing). */
export function AppLogo({ logo = "navBarLogo", style }: AppLogoProps) {
  const sx = {
    height: style?.height ? `${style.height} !important` : "auto",
    width: style?.height ? "auto" : "100%",
  };
  const isSpaceFlorida = useFeature("isSpaceFlorida");
  const isOrbit = useFeature("isOrbit");

  if (isOrbit && isSpaceFlorida) {
    const orbitSx = logo === "navBarLogo" ? getOrbitLogoSx(style) : sx;
    return <SpaceFloridaOrbitLogo sx={orbitSx} />;
  }

  if (isSpaceFlorida) {
    return <SpaceFloridaFullLogo sx={sx} />;
  }

  return <CrowdCoursingLogo sx={sx} />;
}
